import { injectable } from "inversify";
import QARepository from "../../repositories/qa.repository";
import QAAgentEntity from "../../entities/qa_agent.entity";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";
import QAResultEntity from "../../entities/qa_result.entity";
import QAResumeRepository from "../../repositories/qa_resume.repository";

interface _Props {
    qaResumeRepository: QAResumeRepository;
}
@injectable()
export default class GetAudioResultUseCase {
    private qaResumeRepository: QAResumeRepository;
    constructor(props: _Props) {
        this.qaResumeRepository = props.qaResumeRepository;
    }
    public call = async (jobId: string): Promise<Either<ErrorEntity, QAResultEntity>> => {
        return this.qaResumeRepository.getAudioResults({ jobId });
    }
}

export const GetAudioResultUseCaseName = "GetAudioResultUseCase";